import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { QueryKey } from '@/Config/api/queryKey';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicUpdate = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKey.conversationTopics.update],
    onSuccess: (data) => {
      queryClient.setQueryData([QueryKey.conversationTopics.list], (prev: TopicDto[] | undefined) =>
        (prev ?? []).map((item) => (item.id === data.id ? { ...item, ...data } : item)),
      );

      toast.success(t('toast.update_topic.success'));
    },
  });

  const handleUpdateTopic = (topic: TopicDto) => mutation.mutateAsync(topic);

  return { handleUpdateTopic, isPending: mutation.isPending };
};
